var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import useRegistrationForm from "../../../../../hooks/useRegistrationForm";
export var enrichRegistrationFormPropsMsdGlobalCmv = function () {
    var _a = useRegistrationForm(), contents = _a.contents, allCountries = _a.allCountries, eventCountries = _a.eventCountries, hasInternal = _a.hasInternal, isInternalUser = _a.isInternalUser, languages = _a.languages, specialtyInputValue = _a.specialtyInputValue, getTranslatedOptions = _a.getTranslatedOptions, getRegistrationFormProps = _a.getRegistrationFormProps;
    var _b = contents, error_email_invalid = _b.error_email_invalid, error_email_required = _b.error_email_required, error_firstname_required = _b.error_firstname_required, error_lastname_required = _b.error_lastname_required, error_country_required = _b.error_country_required, email = _b.email, phone = _b.phone, affiliation = _b.affiliation, country_of_work = _b.country_of_work, language = _b.language, internal = _b.internal, external = _b.external, firstname = _b.firstname, lastname = _b.lastname, country = _b.country, specialty = _b.specialty, otherSpecialty = _b.otherSpecialty, internal_true_value_label = _b.internal_true_value_label;
    var inputs = [];
    var languageInput = {
        type: "hidden",
        name: "lang_id",
        value: languages[0].value
    };
    if (languages.length > 1) {
        languageInput = {
            label: language,
            name: "lang_id",
            options: languages,
            required: true,
            type: "select"
        };
    }
    inputs.push(languageInput);
    if (hasInternal) {
        inputs.push({
            type: "select",
            label: internal,
            required: true,
            name: "is_internal",
            rules: [
                {
                    required: true,
                    message: ""
                }
            ],
            options: [
                {
                    value: 1,
                    label: internal_true_value_label
                },
                {
                    value: 0,
                    label: external
                }
            ]
        });
    }
    var countriesInput = {
        label: country_of_work,
        name: "country_id_of_work",
        options: allCountries,
        required: true,
        type: "select",
        rules: [
            {
                required: true,
                message: error_country_required
            }
        ]
    };
    if (!isInternalUser) {
        countriesInput = {
            label: country,
            name: "country_id",
            options: eventCountries,
            required: true,
            type: "select",
            rules: [
                {
                    required: true,
                    message: error_country_required
                }
            ]
        };
    }
    inputs.push(countriesInput);
    inputs = __spreadArray(__spreadArray([], inputs, true), [
        {
            type: "text",
            label: firstname,
            required: true,
            name: "firstname",
            rules: [
                {
                    required: true,
                    message: error_firstname_required
                }
            ]
        },
        {
            label: lastname,
            name: "lastname",
            required: true,
            type: "text",
            rules: [
                {
                    required: true,
                    message: error_lastname_required
                }
            ]
        },
        {
            label: specialty,
            name: "specialty",
            options: getTranslatedOptions(),
            required: true,
            type: "select",
            rules: [
                {
                    required: true,
                    message: "Please input your speciality!"
                }
            ]
        }
    ], false);
    if (specialtyInputValue === "Other") {
        inputs.push({
            type: "text",
            label: otherSpecialty,
            required: true,
            name: "other_specialty",
            rules: [
                {
                    required: true,
                    message: "Please input your other speciality!"
                }
            ]
        });
    }
    inputs = __spreadArray(__spreadArray([], inputs, true), [
        {
            label: affiliation,
            name: "affiliation",
            required: true,
            type: "text",
            rules: [
                {
                    required: true,
                    message: "Please input your affiliation!"
                }
            ]
        },
        {
            label: email,
            name: "email",
            required: true,
            type: "email",
            rules: [
                { type: "email", message: error_email_invalid },
                {
                    required: true,
                    message: error_email_required
                }
            ]
        },
        {
            label: phone,
            name: "phone",
            type: "text"
        }
    ], false);
    return getRegistrationFormProps({ inputs: inputs });
};
